// <newsletter-popup> (docs/10 FC-1): tab ↔ window, auto-open once per campaign, remember dismiss/join.
// localStorage cl-nl-v1 = {"v": <settings version>, "s": "seen" | "joined"}; a new version shows again.
const KEY = 'cl-nl-v1';
const read = () => { try { const raw = localStorage.getItem(KEY); if (!raw) return null; if (raw === 'seen' || raw === 'joined') return { v: '*', s: raw }; return JSON.parse(raw); } catch (_) { return null; } };
const write = (v, s) => { try { localStorage.setItem(KEY, JSON.stringify({ v, s })); } catch (_) {} };

class NewsletterPopup extends HTMLElement {
  connectedCallback() {
    this.v = this.dataset.version;
    this.tab = this.querySelector('.nlx-tab');
    this.win = this.querySelector('.nlx-win');
    this.input = this.querySelector('.nlx-fld input');
    this.join = this.querySelector('.nlx-fld .join');

    const st = read();
    const mine = st && (st.v === this.v || st.v === '*') ? st.s : null;
    const posted = document.documentElement.dataset.nlPosted === 'popup';
    const done = this.querySelector('[data-step="done"]:not([hidden])');

    if (posted) {
      if (done) write(this.v, 'joined');
      this.ready();
      requestAnimationFrame(() => this.set(true, false));
    } else {
      if (mine === 'joined' && !this.hasAttribute('data-design')) { this.classList.add('gone'); return; }
      this.ready();
      if (this.hasAttribute('data-auto') && !mine && !this.hasAttribute('data-design') && window.innerHeight <= 1400) {
        const fire = () => {
          // never cover the cart, search or a film: wait until they are closed
          if (document.documentElement.classList.contains('lock')) { this.timer = setTimeout(fire, 2000); return; }
          const now = read(); if (!now || (now.v !== this.v && now.v !== '*')) { write(this.v, 'seen'); this.set(true); }
        };
        this.timer = setTimeout(fire, (+this.dataset.delay || 8) * 1000);
      }
    }

    this.tab?.addEventListener('click', () => this.set(true));
    this.addEventListener('click', (e) => {
      const c = e.target.closest('[data-nlx-close]');
      if (c) { if (c.hasAttribute('data-nlx-finish')) { this.classList.add('gone'); } this.set(false); return; }
      const cp = e.target.closest('[data-copy]');
      if (cp) { navigator.clipboard?.writeText(cp.dataset.copy).then(() => { cp.textContent = cp.dataset.copied; }).catch(() => {}); }
    });
    this.input?.addEventListener('input', () => { this.join.disabled = !this.input.validity.valid || !this.input.value; });
    if (this.input && this.input.value) this.join.disabled = !this.input.validity.valid;
    this.onKey = (e) => {
      if (!this.classList.contains('open')) return;
      if (e.key === 'Escape') this.set(false);
      if (e.key === 'Tab') this.trap(e);
    };
    document.addEventListener('keydown', this.onKey);

    // theme editor: open when the section is selected
    document.addEventListener('shopify:section:select', (e) => { if (this.closest('.shopify-section')?.id === `shopify-section-${e.detail.sectionId}`) this.set(true, false); });
    document.addEventListener('shopify:section:deselect', (e) => { if (this.closest('.shopify-section')?.id === `shopify-section-${e.detail.sectionId}`) this.set(false, false); });
  }
  disconnectedCallback() { clearTimeout(this.timer); document.removeEventListener('keydown', this.onKey); }
  ready() {
    // the closed clip hugs the tab label's real width
    const fit = () => { if (this.tab) this.style.setProperty('--tw', Math.ceil(this.tab.getBoundingClientRect().width) + 'px'); };
    fit(); document.fonts?.ready.then(fit); window.addEventListener('resize', fit);
    requestAnimationFrame(() => this.classList.add('ready'));
  }
  set(open, remember = true) {
    if (open === this.classList.contains('open')) return;
    clearTimeout(this.timer);
    this.classList.toggle('open', open);
    this.win.setAttribute('aria-hidden', String(!open));
    this.tab?.setAttribute('aria-expanded', String(open));
    if (this.tab) this.tab.tabIndex = open ? -1 : 0;
    document.documentElement.classList.toggle('lock', open);
    if (open) {
      this.prev = document.activeElement;
      setTimeout(() => (this.querySelector('.nlx-in:not([hidden]) input[type="email"]') || this.querySelector('.nlx-x'))?.focus({ preventScroll: true }), 400);
    } else {
      if (remember) { const st = read(); if (!st || st.s !== 'joined') write(this.v, this.classList.contains('gone') ? 'joined' : 'seen'); }
      (this.tab && !this.classList.contains('gone') ? this.tab : this.prev)?.focus?.({ preventScroll: true });
    }
  }
  trap(e) {
    const f = [...this.win.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])')].filter((el) => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
}
if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
